import CheckBoxWithLabel from "./CheckBoxWithLabel";

interface CheckboxMapProps {
  options: string[];
  className?: string;
  handelCheckBox?: (id: string) => void;
  checkedArray: string[];
  disabledCheckBox?: string[];
  error?: string;
}

const CheckboxMap = ({
  options,
  className,
  handelCheckBox,
  checkedArray,
  disabledCheckBox,
  error
}: CheckboxMapProps) => {
  return (
    <div className={`flex pr-2 ${className}`}>
      {options.map((arrayItem) => (
        <div className="w-full" key={arrayItem}>
          <CheckBoxWithLabel
            key={arrayItem}
            label={arrayItem}
            disabled={disabledCheckBox?.includes(arrayItem)}
            handelCheckBox={handelCheckBox}
            checked={checkedArray.includes(arrayItem)}
            error={error ? true : false}
          />
        </div>
      ))}
    </div>
  );
};

export default CheckboxMap;
